import { render, staticRenderFns } from "./Bestuur.vue?vue&type=template&id=3bb3d76b&"
import script from "./Bestuur.vue?vue&type=script&lang=js&"
export * from "./Bestuur.vue?vue&type=script&lang=js&"
import style0 from "./Bestuur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports